export default __webpack_public_path__ + "static/media/portfolioImg_1.142e2f1b.png";